"use strict";

// Package Scripts
// Third Party Scripts
// Note. jQuery is added via webpack.ProvidePlugin
import 'lodash';

// Application Scripts: Post Gulp Task
import './Source/js/build/Lib.js';
//import './Source/js/build/App.js';

// Application Scripts
//import './App/PropertyDetail.ts';



// WEBPACK FOOTER //
// ./webpack.entry.ts